import { GlobalController } from 'src/shared/global/GlobalController'
import UnsyncedMessage from './UnsyncedMessage.vue'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: 'unsynced-message',
    name: 'UnsyncedMessage',
    component: UnsyncedMessage,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
